module.exports = __webpack_public_path__ + "svg/fsharp.2c0a29.svg";